import { attr, hasOne, belongsTo } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const Transaction = ApplicationRecord.extend({
  attrs: {
    amount: attr(),
    allow_negative_customer_balance: attr(),
    customer_id: attr(),
    category: attr(),
    description: attr(),
    idempotency_key: attr(),
    metadata: attr(),
    rolled_back_transaction_id: attr(),
    rollback_transaction: hasOne({ type: 'credit_balances-transactions' }),
    rolled_back_transaction: belongsTo({ type: 'credit_balances-transactions' }),
    created_at: attr(),
  },
  static: {
    endpoint: '/transactions',
    jsonapiType: 'credit_balances-transactions',
  },
});

export default Transaction;
